import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NxiNgCommonModule } from '@pershing/nxi-ng-common';
import { ModPreloginModule } from '@pershing/nxi-ng-mod';
import { ModernThemeNavigationComponent } from './components/modern-theme-navigation.component';
import { NavigationBaseComponent } from './components/navigation-base.component';
import { ModernMobileNavComponent } from './components/modern-mobile-nav.component';
import { ADANavComponent } from './components/ada-nav.component';
import { BreadcrumbComponent } from './components/breadcrumb.component';
import { ModernThemeSecondLevelNavigationComponent } from './components/modern-theme-secondlevel-navigation.component';
import { ThirdLevelComponent } from './components/thirdlevel-navigation.component';
import { FourthLevelComponent } from './components/fourthlevel-navigation.component';
import { ScreenerNavComponent } from './components/screener-navigation.component';
import { IconsComponent } from './components/icons.component';
import { ThirdLevelAdaComponent } from './components/thirdlevel-navigation-ada.component';
import { MobileDropDownComponent } from './components/mobile-dropdown-nav.component';
import { MobileFourthLevelNavComponent } from './components/mobile-fourthlevel-nav.component';
import { ThirdLevelMobileComponent } from './components/thirdlevel-navigation-mobile.component';
import { ModernNxiMobileComponent } from './components/modern-nxi-mobile.component';
import { TradingMobileNavComponent } from './components/trading-mobile-nav.component';
import { ScreenerNavCustomComponent } from './components/screener-navigation-custom.component';
import { NxiIconService } from './services/icon.service';
import { NxiMobileService } from './services/nxi-mobile.service';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { GoPaperlessComponent } from './components/go-paperless/go-paperless.component';
import { AllSettingsComponent } from './components/all-settings.component';
import { AdvisorProfilePipe } from './pipes/advisor-profile.pipe';
import { AdvisorInfoComponent } from './components/modern-theme-advisor/advisor-info.component';
import { ContactUsComponent } from './components/modern-theme-advisor/contact-us.component';
import { ContactUsBaseComponent } from './components/modern-theme-advisor/contact-us-base.component';
import { ContactUsAdaptiveComponent } from './components/modern-theme-advisor/contact-us-adaptive.component';
import { AboutUsComponent } from './components/modern-theme-advisor/about-us.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
// import { ContentManagementModule } from '@pershing/nxi-contentmanagement';
import { ModernNavigationService } from './services/modern-navigation.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { PershingCoreRootModule } from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { PageHeaderComponent } from './components/page-header/page-header.component';

const NXI_NAVIGATION_COMPONENTS = [
  NavigationBaseComponent,
  ModernThemeNavigationComponent,
  ModernMobileNavComponent,
  ADANavComponent,
  BreadcrumbComponent,
  ModernThemeSecondLevelNavigationComponent,
  ThirdLevelComponent,
  FourthLevelComponent,
  ScreenerNavComponent,
  IconsComponent,
  ThirdLevelAdaComponent,
  ThirdLevelMobileComponent,
  MobileDropDownComponent,
  MobileFourthLevelNavComponent,
  ModernNxiMobileComponent,
  TradingMobileNavComponent,
  ScreenerNavCustomComponent,
  GoPaperlessComponent,
  AllSettingsComponent,
  PageHeaderComponent,
  ContactUsComponent,
  ContactUsBaseComponent,
  ContactUsAdaptiveComponent,
  AdvisorInfoComponent,
  AboutUsComponent,
  AdvisorProfilePipe,
];

const NXI_NAVIGATION_SERVICES = [
  NxiMobileService,
  NxiIconService,
  ModernNavigationService,
];

@NgModule({
  imports: [
    NxiNgCommonModule,
    RouterModule,
    ModPreloginModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    MatExpansionModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    PershingCoreRootModule,
    PershingCommonModule,
  ],
  declarations: [...NXI_NAVIGATION_COMPONENTS],
  exports: [...NXI_NAVIGATION_COMPONENTS],
  providers: [...NXI_NAVIGATION_SERVICES],
})
export class NxiModernNavigationModule {}
